import React from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import { Container, Row, Col } from "shards-react";
import CircularProgress from "@material-ui/core/CircularProgress";

import Button from "@material-ui/core/Button";
//import { Store } from "../../flux";
import api from "../common/api";
import { Fab, TextField } from "@material-ui/core";
import { NoteAdd } from "@material-ui/icons";
class Pending extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      vouchers: []
    };
  }

  async componentDidMount() {
    await this.getVouchers();
  }

  getVouchers() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.providers().pendingToInvoice(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, vouchers: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, vouchers: [] });
      });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          }
        }
      }
    });

  render() {
    const columns = [
      {
        name: "id",
        label: "Orden de trabajo",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "type.name",
        label: "Tipo de Orden",
        options: {
          filter: true,
          filterType: "select",
          sort: true
        }
      },
      {
        name: "vehicle.plate",
        label: "Patente",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "vehicle.description",
        label: "Vehiculo",
        options: {
          filter: false,
          display: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "reason",
        label: "Motivo",
        options: {
          filter: false,
          display: true,
          filterType: "textField",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                {value.length > 50 ? value.substring(0, 50) + "..." : value}
              </div>
            );
          },
          sort: true
        }
      },
      {
        name: "state",
        label: "Estado OT",
        options: {
          filter: false,
          display: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "user.name",
        label: "Operador AC",
        options: {
          filter: false,
          display: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "total_s_iva_price",
        label: "Subtotal sin IVA",
        options: {
          filter: false,
          filterType: "select",
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                {value
                  .toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD"
                  })
                  .replace(/\./g, "|")
                  .replace(/,/g, ".")
                  .replace(/\|/g, ",")}
              </div>
            );
          }
        }
      },
      {
        name: "schedule.shift_date",
        label: "Turno",
        options: {
          filter: false,
          filterType: "textField",
          sort: true,
          display: true
        }
      },
      {
        name: "buttons",
        label: "Acciones",
        options: {
          filter: false,
          setCellHeaderProps: () => ({}),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0];
            //const rowId = 1
            return (
              <div
                style={{
                  display: "block",
                  textAlign: "right",
                  paddingRight: "30px"
                }}
              >
                <Fab
                  color="primary"
                  aria-label="view"
                  variant="extended"
                  style={{ boxShadow: "none", backgroundColor: "green" }}
                  fontSize="small"
                  className="MuiButtonBase-root MuiFab-sizeSmall my-2"
                  href={"new-voucher/" + rowId}
                >
                  <NoteAdd fontSize="small" />
                </Fab>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: false,
      selectedRows: false,
      selectableRows: false,
      download: false,
      rowsPerPage: 100,
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-0">
        <Row>
          <Col className="p-0">
            <div>
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Comprobantes"
                  data={Object.values(this.state.vouchers)}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Pending;
